import { CommonModule } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SettlementsPageComponent } from './components/settlements-page/settlements-page.component';
import { SettlementApiService } from './services/settlement-api/SettlementApiService';

@NgModule({
  declarations: [SettlementsPageComponent],
  imports: [CommonModule, FormsModule],
  providers: [provideHttpClient(), SettlementApiService],
  exports: [SettlementsPageComponent],
})
export class SettlementsModule { }
